import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../services/user.service';

@Component({
  selector: 'top-exposure-placeholder',
  templateUrl: './top-exposure-placeholder.component.html',
  styleUrls: ['./top-exposure-placeholder.component.scss']
})
export class TopExposurePlaceholderComponent implements OnInit {

  public topExposureItems = [
    {id: 1, name: 'Highest Reach'},
    {id: 2, name: 'Best Engagement'},
    {id: 3, name: 'Best Impact'},
  ];

  @Input() fallbackTitle: string;
  @Input() fallbackMessage: string;

  constructor(private translate: TranslateService, private userService: UserService) { }

  ngOnInit() {
    if (!this.fallbackTitle && this.userService.isFreeUser() && !this.userService.isAdmin) {
      this.fallbackTitle = this.translate.instant('common.invalid_action_by_levels_warning.fallback_title');
    }

    if (!this.fallbackMessage && this.userService.isFreeUser() && !this.userService.isAdmin) {
      this.fallbackMessage = this.translate.instant('common.invalid_action_by_levels_warning.fallback_message');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/top-exposure-placeholder/top-exposure-placeholder.component.ts